<footer class="main-footer">
  <strong>
    <span>Copyright &copy; {{currentYear}}</span>
    <span>&nbsp;&nbsp;HIAE - TRAUMA</span>
  </strong>
  <div class="float-right d-none d-sm-inline-block">
    <b>Version</b>
    <span>:&nbsp;{{version}}</span>
  </div>
</footer>
